import { FormattedMessage } from 'react-intl';
const AdminControlsInsights = () => {
	return (
		<div>
			<p>
				<FormattedMessage
					id="ConfluencePricingPageTeam24.features.adminControlsInsights.content.body"
					defaultMessage="Inspect permissions to specify who can do and create what, and fix permission problems quickly with an admin key. Manage site health, get actionable alerts, and unlock site-level insights, all in one place."
				/>
			</p>
		</div>
	);
};
export default AdminControlsInsights;
